export const LOGO_FULL = "/taeste-logo.png";
export const LOGO_MARK_AE = "/taeste-mark-ae.png";
